<template>
  <div class="volunteer-detail-content">
    <h3 class="title" :style="{ marginBottom: '16px' }">
      <a-icon class="title-icon" theme="twoTone" type="idcard" />
      <span>志愿者</span>
    </h3>
    <div>
      <div class="detail-item">
        <div :class="[{'item-title-mobile': mobileFlag, 'item-title-pc': !mobileFlag}]">
          <span>姓名</span>
        </div>
        <div class="item-content"><span>{{ volunteer.name }}</span></div>
      </div>
      <div class="detail-item">
        <div :class="[{'item-title-mobile': mobileFlag, 'item-title-pc': !mobileFlag}]">
          <span>加入时间</span>
        </div>
        <div class="item-content"><span><a-tag>{{ volunteer.joinDate}}</a-tag></span></div>
      </div>
      <div class="detail-item">
        <div :class="[{'item-title-mobile': mobileFlag, 'item-title-pc': !mobileFlag}]">
          <span>服务时长</span>
        </div>
        <div class="item-content"><span>{{ volunteer.serviceHours}} h</span></div>
      </div>
      <div class="detail-item">
        <div :class="[{'item-title-mobile': mobileFlag, 'item-title-pc': !mobileFlag}]">
          <span>工作单位</span>
        </div>
        <div class="item-content" >
          <span>
            {{volunteer.company.substring(0,30)}}
          </span>
        </div>
      </div>
      <div class="detail-item">
        <div :class="[{'item-title-mobile': mobileFlag, 'item-title-pc': !mobileFlag}]">
          <span>手机</span>
        </div>
        <div class="item-content"><span>{{volunteer.mobile}}</span></div>
      </div>
      <div class="detail-item">
        <div :class="[{'item-title-mobile': mobileFlag, 'item-title-pc': !mobileFlag}]">
          <span>邮箱</span>
        </div>
        <div class="item-content"><span>{{volunteer.email}}</span></div>
      </div>
      <div class="detail-item">
        <div :class="[{'item-title-mobile': mobileFlag, 'item-title-pc': !mobileFlag}]">
          <span>微信</span>
        </div>
        <div class="item-content"><span>{{volunteer.wechatId}}</span></div>
      </div>
    </div>
    <h3 class="title" :style="{ marginBottom: '16px', marginTop: '16px' }">
      <a-icon class="title-icon" theme="twoTone" type="profile" />
      <span>服务明细</span>
      <a-button style="float: right;position: relative;top:3px"
                size="small" type="primary" icon="plus"
                @click="showAddContributionModal">添加活动</a-button>
    </h3>
    <div>
      <div class="table-space">
        <a-table :columns="columns"
                 :dataSource="contributions"
                 :pagination="false"
                 :loading="loading"
                 :scroll="{ x: 800 }"
                 :rowKey="record => record.id">
<!--          <a slot="name" slot-scope="text" href="javascript:;">{{text}}</a>-->
          <span slot="action" slot-scope="record">
<!--           <a href="javascript:;" v-on:click="test(record.key)"><a-icon type="eye" /></a>-->
<!--           <a-divider type="vertical" />-->
           <a href="javascript:;"
              v-on:click="showEditContributionModal(record.key)"><a-icon type="edit" /></a>
           <a-divider type="vertical" />
           <a href="javascript:;"
              v-on:click="deleteContribution(record.key)"><a-icon type="delete" /></a>
         </span>
        </a-table>
      </div>
    </div>

    <a-modal
      title="添加活动"
      :visible="addContributionVisible"
      @ok="handleAddContributionOk"
      :confirmLoading="confirmLoading"
      @cancel="handleAddContributionCancel"
    >
      <a-form
        :form="form"
        @submit="handleSubmit"
      >
        <a-form-item v-bind="formItemLayout">
          <span slot="label">活动名</span>
          <a-input v-decorator="['projectName',
            {
              rules: [{ required: true, message: '请输入活动名!'}],
            }
           ]"/>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="活动时间">
          <a-date-picker @change="changeDate"
                         style="width: 100%" placeholder="选择活动时间" v-decorator="['serviceDate',
            {
              rules: [{ required: true, message: '请选择活动时间!'}],
            }]" />
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">活动地点</span>
          <a-input v-decorator="['address',
            {
              rules: [{ required: true, message: '请选择活动地点!'}]
            }
           ]"/>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="服务时长">
          <a-input-number :min="0" :max="1000" v-decorator="['serviceHours',
          {
            rules: [{
              required: true, message: '请输入服务时长!',
            }]
          }
        ]"/>
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">服务细节</span>
          <a-textarea :autosize="{ minRows: 4, maxRows: 10 }" v-decorator="['details',
            {
              rules: [{ required: true, message: '请输入服务细节!' }]
            }
           ]"/>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      title="添加活动"
      :visible="editContributionVisible"
      @ok="handleEditContributionOk"
      :confirmLoading="confirmLoading"
      @cancel="handleEditContributionCancel"
    >
      <a-form
        :form="editForm"
        @submit="handleSubmit"
      >
        <a-form-item v-bind="formItemLayout">
          <span slot="label">活动名</span>
          <a-input v-decorator="['projectName',
            {initialValue: contribution.projectName,
              rules: [{ required: true, message: '请输入活动名!'}],
            }
           ]"/>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="活动时间">
          <a-date-picker @change="changeDate"
                         style="width: 100%" placeholder="选择活动时间" v-decorator="['serviceDate',
                           {initialValue: moment(contribution.serviceDate, dateFormat)}
                         ]" />
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">活动地点</span>
          <a-input v-decorator="['address',
            {initialValue: contribution.address,
              rules: [{ required: true, message: '请选择活动地点!'}]
            }
           ]"/>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="服务时长">
          <a-input-number :min="0" :max="1000" v-decorator="['serviceHours',
          {initialValue: contribution.serviceHours,
            rules: [{
              required: true, message: '请输入服务时长!',
            }]
          }
        ]"/>
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">服务细节</span>
          <a-textarea :autosize="{ minRows: 4, maxRows: 10 }" v-decorator="['details',
            {initialValue: contribution.details,
              rules: [{ required: true, message: '请输入服务细节!' }]
            }
           ]"/>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      title="服务详情"
      :visible="addUserVisible"
      @ok="ok()"
      :confirmLoading="confirmLoading"
      @cancel="cancel()"
    >
      <div class="clear">
        <div class="contribution-item">
          <div class="contribution-title"><span>日期</span></div>
          <div class="contribution-content"><span><a-tag>1998-10-17</a-tag></span></div>
        </div>
        <div class="contribution-item">
          <div class="contribution-title"><span>地址</span></div>
          <div class="contribution-content"><span>静安党校</span></div>
        </div>
        <div class="contribution-item">
          <div class="contribution-title"><span>服务时长</span></div>
          <div class="contribution-content"><span>6hours</span></div>
        </div>
        <div class="contribution-item">
          <div class="contribution-title"><span>详细内容</span></div>
          <div class="contribution-content">
            <a-timeline class="contribution-details">
              <a-timeline-item>Create a services site 2015-09-01</a-timeline-item>
              <a-timeline-item>Solve initial network problems 2015-09-01</a-timeline-item>
              <a-timeline-item>Technical testing 2015-09-01</a-timeline-item>
              <a-timeline-item>Network problems being solved 2015-09-01</a-timeline-item>
            </a-timeline>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="clear"></div>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
import store from '../store';

const columns = [{
  dataIndex: 'projectName',
  key: 'projectName',
  // slots: { title: '姓名' },
  // scopedSlots: { customRender: 'customTitle' },
  title: '活动名',
  fixed: 'left',
  // className: 'week-num-col',
},
{
  title: '时间',
  dataIndex: 'serviceDate',
  key: 'serviceDate',
  // className: 'week-num-col',
},
{
  title: '地点',
  dataIndex: 'address',
  key: 'address',
  // className: 'week-num-col',
},
{
  title: '时长',
  dataIndex: 'serviceHours',
  key: 'serviceHours',
  // className: 'week-num-col',
},
{
  title: '操作',
  key: 'action',
  scopedSlots: { customRender: 'action' },
  // className: 'week-num-col',
}];

export default {
  name: 'Volunteer-detail',
  data() {
    return {
      volunteer: {},
      columns,
      addUserVisible: false,
      confirmLoading: false,
      addContributionVisible: false,
      editContributionVisible: false,
      contributions: [],
      contribution: {},
      dateString: '',
      mobileFlag: false,
      dateFormat: 'YYYY-MM-DD',
      loading: true,
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
      },
    };
  },
  beforeCreate() {
    this.hasVolunteerRole();
    this.form = this.$form.createForm(this);
    this.editForm = this.$form.createForm(this);
  },
  created() {
    this.adaptMobile();
    this.volunteer = store.state.volunteer;
    this.getContributionsByVolunteerId(this.volunteer.id);
  },
  methods: {
    moment,
    test(index, id) {
      console.log(`hahaha:${index}`);
      console.log(`tetsts:${id}`);
    },
    changeDate(date, dateString) {
      this.dateString = dateString;
      console.log(dateString);
    },
    async getContributionsByVolunteerId(volunteerId) {
      await this.axios({
        method: 'get',
        url: `/service/mgt/contribution/${volunteerId}`,
      }).then((response) => {
        if (response.data.code === 0) {
          const tempContributions = response.data.data;
          for (let i = 0; i < tempContributions.length; i += 1) {
            // const key = 'key';
            const tempContribution = tempContributions[i];
            tempContribution.key = i;
            this.contributions.push(tempContribution);
          }
          this.loading = false;
        } else {
          this.$message.error(response.data.msg);
        }
      }).catch((response) => {
        console.log(response);
        this.$message.error('服务器发生错误');
      });
    },
    handleAddContributionCancel() {
      this.addContributionVisible = false;
    },
    handleEditContributionCancel() {
      this.editContributionVisible = false;
    },
    handleAddContributionOk() {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // eslint-disable-next-line no-param-reassign
          values.serviceDate = this.dateString;
          // eslint-disable-next-line no-param-reassign
          values.volunteerId = this.volunteer.id;
          console.log('Received values of form: ', values);
          this.axios({
            method: 'post',
            url: '/service/mgt/contribution/submit',
            data: values,
          }).then((response) => {
            if (response.data.code === 0) {
              this.$message.success('添加成功', 1);
              this.addContributionVisible = false;
              this.contributions = [];
              this.getContributionsByVolunteerId(this.volunteer.id);
              this.volunteer.serviceHours = this.volunteer.serviceHours + values.serviceHours;
            } else {
              this.$message.error(response.data.msg);
            }
          }).catch((response) => {
            console.log(response.data);
          });
        }
      });
    },
    handleEditContributionOk() {
      this.editForm.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // eslint-disable-next-line no-param-reassign,max-len
          values.serviceDate = this.dateString === null ? this.contribution.serviceDate : this.dateString;
          // eslint-disable-next-line no-param-reassign
          values.volunteerId = this.volunteer.id;
          // eslint-disable-next-line no-param-reassign
          values.id = this.contribution.id;
          console.log('Received values of form: ', values);
          this.axios({
            method: 'post',
            url: '/service/mgt/contribution/submit',
            data: values,
          }).then((response) => {
            if (response.data.code === 0) {
              this.$message.success('修改成功', 1);
              this.editContributionVisible = false;
              this.contributions = [];
              this.getContributionsByVolunteerId(this.volunteer.id);
              // eslint-disable-next-line max-len
              this.volunteer.serviceHours = this.volunteer.serviceHours + values.serviceHours - this.contribution.serviceHours;
            } else {
              this.$message.error(response.data.msg);
            }
          }).catch((response) => {
            console.log(response.data);
          });
        }
      });
    },
    hasVolunteerRole() {
      if (store.state.user.roles.indexOf('VADMIN') < 0) {
        this.$router.push('/layout/book-card');
      }
    },
    showAddContributionModal() {
      // this.volunteer.serviceHours = 20;
      this.form = this.$form.createForm(this);
      this.addContributionVisible = true;
    },
    showEditContributionModal(key) {
      // this.volunteer.serviceHours = 20;
      console.log(key);
      this.contribution = this.contributions[key];
      this.editForm = this.$form.createForm(this);
      this.dateString = null;
      this.editContributionVisible = true;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    deleteContribution(key) {
      this.contribution = this.contributions[key];
      const that = this;
      this.$confirm({
        title: '确定要删掉这条数据吗?',
        // iconType: 'check-circle',
        // content: '反馈已复制到剪贴板!',
        onOk() {
          that.axios.get(`/service/mgt/contribution/delete/${that.contribution.id}`).then((response) => {
            if (response.data.code === 0) {
              that.$message.success('删除成功', 1);
              that.contributions = [];
              console.log(that.volunteer.serviceHours);
              console.log(that.contribution.serviceHours);
              // eslint-disable-next-line max-len,operator-assignment
              that.volunteer.serviceHours = that.volunteer.serviceHours - that.contribution.serviceHours;
              that.getContributionsByVolunteerId(store.state.volunteer.id);
            } else {
              that.$message.error('删除失败！');
            }
          }).catch((response) => {
            console.log(response);
            that.$message.error('服务器发生错误！');
          });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    ok() {
      this.addUserVisible = false;
    },
    cancel() {
      this.addUserVisible = false;
    },
    adaptMobile() {
      if (this.isMobile()) {
        this.mobileFlag = true;
      }
    },
  },
};
</script>

<style scoped>
  .volunteer-detail-content{
    max-width: 800px;
    margin-right: auto;
    margin-left: auto;
    /*margin-left: 200px;*/
  }
  .detail-item{
    width: 100%;
    height: 30px;
  }
  .contribution-item{
    width: 100%;
    margin-bottom: 10px;
    min-height: 20px;
  }
  .contribution-title{
    width: 100px;
    text-align: right;
    float: left;
    margin-right: 10px;
  }
  .contribution-title>span{
    font-weight: 600;
  }
  .contribution-content{
    float: left;
  }
  .item-title-mobile{
    /*max-width: 200px ;*/
    /*min-width: 150px;*/
    width: 60px;
    text-align: right;
    float: left;
    margin-right: 10px;
    font-weight: 800;
  }
  .item-title-pc{
    /*max-width: 200px ;*/
    /*min-width: 150px;*/
    width: 100px;
    text-align: right;
    float: left;
    margin-right: 10px;
    font-weight: 800;
  }
  .item-title>span{
    font-weight: 600;
  }
  .item-content {
    text-align: left;
    float: left;
  }
  .title>span{
    font-weight: 800;
  }
  .title-icon{
    position: relative;
    font-size: 20px;
    margin-right: 10px;
  }
  .table-space {
    max-width: 800px;
  }
  .clear{
    clear: both;
  }
  .contribution-details{
    margin-top: 8px;
  }
</style>
